import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { API_URL, securityHeaders } from "../Constants";
import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";

/*****************fetch all Applicants */
const fetchEchoMagazine = async (data) => {
  return await axios.get(
    API_URL +
      `/api/EchoMagazine/GetEchoMagazine/${data?.type}/${data?.pageSize}/${
        data?.pageNumber
      }${!isEmpty(data?.search) ? "?SearchBy=" + data?.search : ""}${
        null !== data?.selectedActivity && !isEmpty(data?.search)
          ? "&IsActive=" + data?.selectedActivity
          : null !== data?.selectedActivity && isEmpty(data?.search)
          ? "?IsActive=" + data?.selectedActivity
          : ""
      }`,
    {
      headers: securityHeaders,
    }
  );
};

export const useFetchEchoMagazine = (data) => {
  return useQuery({
    queryKey: ["echoMagazine"],
    queryFn: () => fetchEchoMagazine(data),
    enabled: true,
  });
};

/*****************Delete */
const deleteEchoMagazine = (id) => {
  return axios.post(
    API_URL + `/api/EchoMagazine/DeleteEchoMagazine/${id}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

export const useDeleteEchoMagazine = () => {
  return useMutation(deleteEchoMagazine);
};
